'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _progressiveImageConstants = require('./progressiveImageConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Lib
var initialState = Immutable.Map();

// Constants


var imageLoaded = function imageLoaded(state, action) {
    if (!action.source) {
        console.warn('An image without a source is being marked as loaded.');
        return state;
    }
    return state.set(action.source, true);
};

/**
 * Simple tracks a map of image sources that have been loaded.
 * Used by the ProgressiveImages when displaying a drag preview to ensure that a flash of loading content
 * isn't shown.
 */

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _progressiveImageConstants.IMAGE_LOADED:
            return imageLoaded(state, action);
        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/images/progressiveImages/progressiveImageReducer.js
// module id = 1905
// module chunks = 0